import React from 'react'
import { useValidationHint } from '../useValidationHint'

const useSellerValidation = (params: {
  hasPendingSelection: boolean
  isChildrenLoading: boolean
  isChildDropdownOpen: boolean
  onValidate: () => void
}) => {
  const { hasPendingSelection, isChildrenLoading, isChildDropdownOpen, onValidate } = params
  const [showValidationHint, setShowValidationHint] = useValidationHint(
    hasPendingSelection,
    isChildDropdownOpen,
  )

  const handleValidate = React.useCallback(() => {
    onValidate()
    setShowValidationHint(false)
  }, [onValidate, setShowValidationHint])

  return {
    hasPendingSelection,
    isChildrenLoading,
    showValidationHint,
    handleValidate,
  }
}

export { useSellerValidation }
